import i18n from '@/i18n'
import { userService } from '@/services/user.service'
import { mapActions } from 'vuex'
import { SnackbarStyle, DialogType } from '@/constants/constants'
import { DialogUser } from "@/tools/dialog"
import UserDialogInternationalizationTabComponent from './tabs/internationalization/UserDialogInternationalizationTabComponent.vue'
import UserDialogDataTabComponent from './tabs/data/UserDialogDataTabComponent.vue'
import UserDialogEnterpriseTabComponent from './tabs/enterprise/UserDialogEnterpriseTabComponent.vue'
import UserDialogLoginTabComponent from './tabs/login/UserDialogLoginTabComponent.vue'
import UserDialogCommentTabComponent from './tabs/comment/UserDialogCommentTabComponent.vue'
import UserDialogThingAssignmentTabComponent from './tabs/thing-assignment/UserDialogThingAssignmentTabComponent.vue'
import { REGEX } from '@/constants/constants'
import moment from 'moment'
import Vue from 'vue'
import { thingService } from '@/services/thing.service'
import { enterpriseService } from '@/services/enterprise.service'
import { authService } from '@/services/auth.service'
import { clone } from 'ramda'
import equal from 'fast-deep-equal'

export default {
    name: 'UserDialogComponent',
    components: {
        UserDialogDataTabComponent,
        UserDialogEnterpriseTabComponent,
        UserDialogLoginTabComponent,
        UserDialogCommentTabComponent,
        UserDialogThingAssignmentTabComponent,
        UserDialogInternationalizationTabComponent
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // tab seleccionada
        tab: null,
        // modelos de los tabs      
        userDialogDataTab: {
            key: 'userDialogDataTab',
            tab: i18n.t('user.editDialog.tabs.personalInformation'),
            tooltip: i18n.t('user.editDialog.tabs.personalInformationTooltip'),
            icon: 'mdi-form-textbox',
            disabled: false,
            content: {
                _uid: 'oLkbANttlu',
                component: 'UserDialogDataTabComponent',
                headline: 'UserDialogDataTabComponent'
            },
            model: {
                username: null,
                fastAccess: false,
                firstName: null,
                lastName: null,
                password: null,
                repeatPassword: null,
                email: null,
                update: false
            },
            validForm: false
        },
        userDialogEnterpriseTab: {
            key: 'userDialogEnterpriseTab',
            tab: i18n.t('user.editDialog.tabs.enterprises'),
            tooltip: i18n.t('user.editDialog.tabs.enterprisesTooltip'),
            icon: 'mdi-shield-home',
            disabled: false,
            content: {
                _uid: 'oLkbANttlv',
                component: 'UserDialogEnterpriseTabComponent',
                headline: 'UserDialogEnterpriseTabComponent'
            },
            model: {
                enterprisesData: [],
                enterprises: [],
                profileId: null,
                autoUpdateUserEnterprises: false,
                update: false
            },
            validForm: false
        },
        userDialogLoginTab: {
            key: 'userDialogLoginTab',
            tab: i18n.t('user.editDialog.tabs.loginConfiguration'),
            tooltip: i18n.t('user.editDialog.tabs.loginConfigurationTooltip'),
            icon: 'mdi-login-variant',
            disabled: false,
            content: {
                _uid: 'd0Kg1Aw8Pq',
                component: 'UserDialogLoginTabComponent',
                headline: 'UserDialogLoginTabComponent'
            },
            model: {
                enabled: true,
                insideUser: false,
                isExternal: false,
                remoteAccess: false,
                dateRestriction: false,
                sinceDate: null,
                toDate: null,
                modifyPasswordNextLogIn: false,
                passwordExpiration: false,
                passwordExpirationDays: 0,
                inactivityDisconnection: false,
                authorizedIpRange: false,
                ipRangeFrom: null,
                ipRangeTo: null,
                update: false
            },
            validForm: false
        },
        userDialogThingAssignmentTab: {
            key: 'userDialogThingAssignmentTab',
            tab: i18n.t('user.editDialog.tabs.equipmentsAssignment'),
            tooltip: i18n.t('user.editDialog.tabs.equipmentsAssignment'),
            icon: 'mdi-checkbox-multiple-marked-outline',
            disabled: true,
            content: {
                _uid: 'wNXSZzWtiS',
                component: 'UserDialogThingAssignmentTabComponent',
                headline: 'UserDialogThingAssignmentTabComponent'
            },
            model: {
                // datos del árbol
                data: [],
                // datos que deben aparecer seleccionados
                selectedData: [],
                // resultado
                result: [],
                update: false
            },
            validForm: false
        },
        userDialogCommentTab: {
            key: 'userDialogCommentTab',
            tab: i18n.t('user.editDialog.tabs.comment'),
            tooltip: i18n.t('user.editDialog.tabs.comment'),
            icon: 'mdi-form-textarea',
            disabled: false,
            content: {
                _uid: '4i5SF6zEZh',
                component: 'UserDialogCommentTabComponent',
                headline: 'UserDialogCommentTabComponent'
            },
            model: {
                comment: null,
                update: false
            },
            validForm: false
        },  
        userDialogInternationalizationTab: {
            key: 'userDialogInternationalizationTab',
            tab: i18n.t('user.editDialog.tabs.internationalization'),
            tooltip: i18n.t('user.editDialog.tabs.internationalizationTooltip'),
            icon: 'mdi-earth',
            disabled: false,
            content: {
                _uid: '1i7SF6zEgh',
                component: 'UserDialogInternationalizationTabComponent',
                headline: 'UserDialogInternationalizationTabComponent'
            },
            model: {
                internationalization: {
                    unit:null,
                    date:null,
                    dateMask:null,
                }
            },
            validForm: false
        },
        tabs: [],
        // reglas de validación
        validationRules: {
            required: value => !!value || `${i18n.t('required')}`,
            requiredWithCheck: (check, value) => !check || !!value || `${i18n.t('required')}`,
            min: (value, minValue) => !value || value.length >= minValue || `${i18n.t('min', { min: minValue })}`,
            samePassword: (password, repeatPassword) => {
                password = password === undefined || password === '' ? '' : password;
                repeatPassword = repeatPassword === undefined || repeatPassword === '' ? '' : repeatPassword;
                return password === repeatPassword || `${i18n.t('user.differentPasswords')}`
            },
            notUsername: (password, username) => {
                if (!password || !username) return true
                const searchText = username.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
                return ((password.match(new RegExp(searchText, 'i')) == null) || `${i18n.t('user.passwordIncludesUsername')}`)
            },
            onlyLetters: value => !value || REGEX.letters.test(value.toString()) || `${i18n.t('hintOnlyLetters')}`,
            email: value => !value || REGEX.email.test(value.toString()) || `${i18n.t('user.invalidEmail')}`,
            twoDatesValidation: (firstDate, secondDate) => {
                return !firstDate || !secondDate || moment(firstDate, 'DD/MM/YYYY').isSameOrBefore(moment(secondDate, 'DD/MM/YYYY')) || `${i18n.t('user.invalidDates')}`
            },
            ip: value => !value || REGEX.ip.test(value.toString()) || `${i18n.t('user.invalidIP')}`,
            ipRange: (firstIP, secondIP) => {
                if (firstIP && secondIP) {
                    const firstIPNumberValue = Number(
                        firstIP.split('.')
                            .map(d => ('000' + d).substr(-3))
                            .join(''))
                    const secondIPNumberValue = Number(
                        secondIP.split('.')
                            .map(d => ('000' + d).substr(-3))
                            .join(''))
                    return (secondIPNumberValue >= firstIPNumberValue) || `${i18n.t('user.invalidIpRange')}`
                } else {
                    return true
                } 
            }
        },
        // flag para resetear validaciones en los formularios
        resetForms: false,
        // copia de los ids de las ultimas empresas asignadas al user, para evitar traer una nueva lista anidada de cosas
        enterprisesCloned: []
    }),
    computed: {
    },
    created() {
    },
    beforeMount() {
        // pusheo los tabs
        this.tabs.push(this.userDialogDataTab)
        this.tabs.push(this.userDialogEnterpriseTab)
        this.tabs.push(this.userDialogThingAssignmentTab)
        this.tabs.push(this.userDialogLoginTab)
        this.tabs.push(this.userDialogCommentTab)
        this.tabs.push(this.userDialogInternationalizationTab)
    },
    mounted() {
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            // tab de internacionalizacion
            this.userDialogInternationalizationTab.model.internationalization.unit = null
            this.userDialogInternationalizationTab.model.internationalization.date = null
            this.userDialogInternationalizationTab.model.internationalization.dateMask = null

            // tab de datos personales
            this.userDialogDataTab.model.username = null
            this.userDialogDataTab.model.password = null
            this.userDialogDataTab.model.repeatPassword = null
            this.userDialogDataTab.model.firstName = null
            this.userDialogDataTab.model.lastName = null
            this.userDialogDataTab.model.email = null
            this.userDialogDataTab.model.fastAccess = false

            // tab de empresas y perfiles
            this.userDialogEnterpriseTab.model.enterprisesData = []
            this.userDialogEnterpriseTab.model.enterprises = []
            this.userDialogEnterpriseTab.model.profileId = null

            // tab de configuraciones de inicio de sesión
            this.userDialogLoginTab.model.enabled = true
            this.userDialogLoginTab.model.insideUser = false
            this.userDialogLoginTab.model.isExternal = false
            this.userDialogLoginTab.model.remoteAccess = false
            this.userDialogLoginTab.model.dateRestriction = false
            this.userDialogLoginTab.model.sinceDate = null
            this.userDialogLoginTab.model.toDate = null
            this.userDialogLoginTab.model.modifyPasswordNextLogIn = false
            this.userDialogLoginTab.model.passwordExpiration = false
            this.userDialogLoginTab.model.passwordExpirationDays = 0
            this.userDialogLoginTab.model.inactivityDisconnection = false
            this.userDialogLoginTab.model.authorizedIpRange = false
            this.userDialogLoginTab.model.ipRangeFrom = null
            this.userDialogLoginTab.model.ipRangeTo = null

            // tab de equipos asignados
            this.userDialogThingAssignmentTab.model.data = []
            this.userDialogThingAssignmentTab.model.selectedData = []
            this.userDialogThingAssignmentTab.model.result = []

            // tab de empresas - siempre resetear para evitar problemas de caché
            this.userDialogEnterpriseTab.model.autoUpdateUserEnterprises = false

            // tab de comentario
            this.userDialogCommentTab.model.comment = null

            // updates
            this.userDialogDataTab.model.update = false
            this.userDialogEnterpriseTab.model.update = false
            this.userDialogLoginTab.model.update = false
            this.userDialogThingAssignmentTab.model.update = false
            this.userDialogCommentTab.model.update = false

            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function() {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogUser)
            this.resetFields()
        },
        /**
         * Guardar
         */
        save() {
            const userDto = this.getDto(this.model.update)
            if (this.model.isClone) {
                userDto._id = null
            }
            if (this.model.update) {
                userService.update(userDto).then(async () => {
                    // Llamada para establecer el estado de autoUpdateUserEnterprises
                    await userService.setAutoUpdateEnterprises(userDto._id, this.userDialogEnterpriseTab.model.autoUpdateUserEnterprises)
                    
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('user.successUpdateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    await authService.refreshTokenPayload()
                    this.$emit('commitUser')
                    this.cancel()
                })
            } else {
                if(userDto.email !== null){
                    this.openDialog({ visible: true,
                    title: this.$t('user.sendWelcomeEmailTitle'),
                    text: this.$t('user.sendWelcomeEmailText', { email: userDto.email }),
                    type: DialogType.QUESTION,
                    actionButtons: true,
                    yesAction: () => { this.saveAction(userDto, true) },
                    noAction: () => { this.saveAction(userDto, false) } })
                }else{
                    userDto.email = ''
                    this.saveAction(userDto, false)
                }
                
            }
        },
        /**
         * Se ejecuta cuando se crea un nuevo usuario de acuerdo a la acción del diálogo
         * que pregunta si se quiere enviar un correo de bienvenida
         * @param {*} userDto
         * @param {*} sendEmail
         */
        saveAction (userDto, sendEmail = false) {
            userService.create(userDto, sendEmail).then(async (createdUser) => {
                // Llamada para establecer el estado de autoUpdateUserEnterprises
                await userService.setAutoUpdateEnterprises(createdUser._id, this.userDialogEnterpriseTab.model.autoUpdateUserEnterprises)

                this.showSnackbar({
                    visible: true,
                    text: this.$t('user.successCreateMessage'),
                    timeout: 6000,
                    style: SnackbarStyle.SUCCESS
                })
                await authService.refreshTokenPayload()
                this.$emit('commitUser')
                this.cancel()
            })
        },
        /**
         * Genera el DTO para actualizar / crear
         * @param {*} update
         */
        getDto(update = false) {
            // Obtener las empresas, grupos Y cosas seleccionados completos a partir de los ids de las cosas
            const { userEnterprises, userGroups, userThings } = userService.getThingsGroupsEnterprises(this.userDialogThingAssignmentTab.model.result)
            // Obtener los ids de los nodos modificados (sólo los que tienen la prop disabled en false)
            const thigsAssignmentModified = userService.getModifiedIds(this.userDialogThingAssignmentTab.model.result)

            this.userDialogDataTab.model.password = this.userDialogDataTab.model.password === '' ? undefined : this.userDialogDataTab.model.password
            const result = {
                username: this.userDialogDataTab.model.username,
                password: this.userDialogDataTab.model.password,
                firstName: this.userDialogDataTab.model.firstName,
                lastName: this.userDialogDataTab.model.lastName,
                email: this.userDialogDataTab.model.email,
                fastAccess: this.userDialogDataTab.model.fastAccess,
                profileId: this.userDialogEnterpriseTab.model.profileId,
                enterprises: this.userDialogEnterpriseTab.model.enterprises,
                enabled: this.userDialogLoginTab.model.enabled,
                insideUser: this.userDialogLoginTab.model.insideUser,
                isExternal: this.userDialogLoginTab.model.isExternal,
                remoteAccess: this.userDialogLoginTab.model.remoteAccess,
                dateRestriction: this.userDialogLoginTab.model.dateRestriction,
                sinceDate: this.dateTimestamp(this.userDialogLoginTab.model.sinceDate),
                toDate: this.dateTimestamp(this.userDialogLoginTab.model.toDate),
                authorizedIpRange: this.userDialogLoginTab.model.authorizedIpRange,
                ipRangeFrom: this.userDialogLoginTab.model.ipRangeFrom,
                ipRangeTo: this.userDialogLoginTab.model.ipRangeTo,
                modifyPasswordNextLogIn: this.userDialogLoginTab.model.modifyPasswordNextLogIn,
                inactivityDisconnection: this.userDialogLoginTab.model.inactivityDisconnection,
                passwordExpiration: this.userDialogLoginTab.model.passwordExpiration,
                passwordExpirationDays: this.userDialogLoginTab.model.passwordExpirationDays,
                userThings,
                userEnterprises,
                userGroups,
                thigsAssignmentModified,
                comment: this.userDialogCommentTab.model.comment,
                internationalization: this.userDialogInternationalizationTab.model.internationalization,
            }
            if (update) {
                result._id = this.model._id
            }
            return result
        },
        /**
         * Convierte una fecha en formato DD/MM/YYYY a timestamp unix
         */
        dateTimestamp(date) {
            return date ? moment(date).unix() : null
        },
        /**
         * Captura un evento cuando se modifica la selección de empresas del usuario,
         * para habilitar/deshabilitar el tab de asignación de equipos
         * @param {*} enterprises
         */
        disableThingsAssingmentTab(enterprises) {
            if (enterprises.length > 0 && !equal(enterprises, this.enterprisesCloned)) {
                this.enterprisesCloned = []
                this.enterprisesCloned.cleanAndUpdate(enterprises)
                const { userEnterprises, userGroups, userThings } = userService.getThingsGroupsEnterprises(this.userDialogThingAssignmentTab.model.selectedData)
                this.userDialogThingAssignmentTab.disabled = false
                thingService.getThingsNestedInEnterprises(
                    enterprises, [...userEnterprises, ...userGroups, ...userThings], this.model._id).then(data => {
                        this.userDialogThingAssignmentTab.model.data = data
                        this.userDialogThingAssignmentTab.model.selectedData = clone(this.userDialogThingAssignmentTab.model.result
                            .filter(element => (element.nodeType === 'ENTERPRISE' && enterprises.includes(element.id)) || (element.nodeType !== 'ENTERPRISE' && enterprises.includes(element.enterpriseId))))
                        this.userDialogThingAssignmentTab.model.result = clone(this.userDialogThingAssignmentTab.model.selectedData)
                    })
            } else if (enterprises.length === 0) {
                this.userDialogThingAssignmentTab.disabled = true
                this.userDialogThingAssignmentTab.model.data = []
                this.userDialogThingAssignmentTab.model.selectedData = []
                this.userDialogThingAssignmentTab.model.result = []
            }
        }
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler: async function (newModel) {
                if (newModel) {
                    // tab de datos personales
                    this.userDialogDataTab.model.username = newModel.username;
                    this.userDialogDataTab.model.password = newModel.password;
                    this.userDialogDataTab.model.repeatPassword = newModel.password;
                    this.userDialogDataTab.model.firstName = newModel.firstName;
                    this.userDialogDataTab.model.lastName = newModel.lastName;
                    this.userDialogDataTab.model.email = newModel.email;
                    this.userDialogDataTab.model.fastAccess = newModel.fastAccess;

                    // tab de configuraciones de inicio de sesión
                    this.userDialogLoginTab.model.enabled = newModel.enabled;
                    this.userDialogLoginTab.model.insideUser = newModel.insideUser;
                    this.userDialogLoginTab.model.isExternal = newModel.isExternal;
                    this.userDialogLoginTab.model.remoteAccess = newModel.remoteAccess;
                    this.userDialogLoginTab.model.dateRestriction = newModel.dateRestriction;
                    let sinceDate = null;
                    let toDate = null;
                    // To support old string dates
                    if (moment.unix(newModel.sinceDate).isValid()) {
                        sinceDate = moment.unix(newModel.sinceDate).toISOString().substring(0, 10);
                    } else if (moment(newModel.sinceDate).isValid()) {
                        sinceDate = moment(newModel.sinceDate).toISOString().substring(0, 10);
                    }
                    if (moment.unix(newModel.toDate).isValid()) {
                        toDate = moment.unix(newModel.toDate).toISOString().substring(0, 10);
                    } else if (moment(newModel.toDate).isValid()) {
                        toDate = moment(newModel.toDate).toISOString().substring(0, 10);
                    }
                    this.userDialogLoginTab.model.sinceDate = sinceDate;
                    this.userDialogLoginTab.model.toDate = toDate;
                    this.userDialogLoginTab.model.modifyPasswordNextLogIn = newModel.modifyPasswordNextLogIn;
                    this.userDialogLoginTab.model.passwordExpiration = newModel.passwordExpiration;
                    this.userDialogLoginTab.model.passwordExpirationDays = newModel.passwordExpirationDays;
                    this.userDialogLoginTab.model.inactivityDisconnection = newModel.inactivityDisconnection;
                    this.userDialogLoginTab.model.authorizedIpRange = newModel.authorizedIpRange;
                    this.userDialogLoginTab.model.ipRangeFrom = newModel.ipRangeFrom;
                    this.userDialogLoginTab.model.ipRangeTo = newModel.ipRangeTo;

                    // empresas asignadas al usuario
                    this.userDialogEnterpriseTab.model.enterprisesData = await enterpriseService.getAllForSelectorUserABM(newModel.enterprises);
                    this.userDialogEnterpriseTab.model.enterprises.cleanAndUpdate(newModel.enterprises);
                    this.enterprisesCloned = [];
                    this.enterprisesCloned.cleanAndUpdate(newModel.enterprises);

                    //perfil
                    this.userDialogEnterpriseTab.model.profileId = newModel.profileId;

                    // obtener el estado de autoUpdateUserEnterprises si es una actualización
                    if (newModel.update && newModel._id) {
                        try {
                            const autoUpdateState = await userService.getAutoUpdateEnterprises(newModel._id)
                            this.userDialogEnterpriseTab.model.autoUpdateUserEnterprises = autoUpdateState
                        } catch (exception) {
                            console.log('Error fetching autoUpdateUserEnterprises state:', exception)
                            this.userDialogEnterpriseTab.model.autoUpdateUserEnterprises = false
                        }
                    } else {
                        // Para nuevos usuarios, resetear a false
                        this.userDialogEnterpriseTab.model.autoUpdateUserEnterprises = false
                    }

                    // tab de asignación de equipos
                    // estructura de cosas anidadas para el diálogo selector
                    this.userDialogThingAssignmentTab.model.data = await thingService.getThingsNestedInEnterprises(
                        newModel.enterprises, [...newModel.userEnterprises, ...newModel.userGroups, ...newModel.userThings], newModel._id);
                    // obtener las cosas a partir de los arreglos userEnterprises, userGroups, userThings
                    this.userDialogThingAssignmentTab.model.selectedData = userService.getSelectedData(
                        this.userDialogThingAssignmentTab.model.data, newModel.userEnterprises, newModel.userGroups, clone(newModel.userThings));
                    this.userDialogThingAssignmentTab.model.result = clone(this.userDialogThingAssignmentTab.model.selectedData);

                    // si no hay empresas seleccionadas, deshabilito el tab de asignación de equipos
                    this.userDialogThingAssignmentTab.disabled = newModel.enterprises.length === 0;
                    
                    // tab de comentario
                    this.userDialogCommentTab.model.comment = newModel.comment;

                    // tab de internacionalización
                    this.userDialogInternationalizationTab.model.internationalization = newModel.internationalization? newModel.internationalization:this.userDialogInternationalizationTab.model.internationalization;

                    // updates
                    this.userDialogDataTab.model.update = newModel.update;
                    this.userDialogEnterpriseTab.model.update = newModel.update;
                    this.userDialogLoginTab.model.update = newModel.update;
                    this.userDialogThingAssignmentTab.model.update = newModel.update;
                    this.userDialogCommentTab.model.update = newModel.update;

                    
                }
            }
        }
    }
}
